// extracted by mini-css-extract-plugin
module.exports = {"loader":"IconCard_loader__1QEVW","root":"IconCard_root__j33UJ"};